import styled from "@emotion/styled";

const TextWithImagesBlockTexts = styled.div`
  ${({ theme }) => theme.breakpoints.down("lg")} {
    display: contents;
  }

  ${({ theme }) => theme.breakpoints.up("lg")} {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
`;

export default TextWithImagesBlockTexts;
